<template>
  <div v-if="item" class="mt-2">
    <div class="col-12" v-for="v in item.options" v-bind:key="v.id">
      <span v-if="v.enabled">{{v.title}}<i class="fa fa-check"></i></span>
      <span v-else>{{v.title}}<i class="fa fa-ban"></i></span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["item"],
  methods: {
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/action-items/types/MemberMessaging.vue